import { isValidPhoneNumber } from "libphonenumber-js/min";
import * as Yup from "yup";
const guestEntrySchema = Yup.object()
  .shape({
    firstname: Yup.string().nullable(),
    mobile: Yup.string().nullable(),
    country_code: Yup.string().nullable(),
  })
  .test(
    "name-or-mobile-required",
    "Either both Name and mobile should be filled, or both should be empty.",
    function (value) {
      const { firstname, mobile } = value || {};
      const nameProvided = firstname?.trim().length > 0;
      const mobileProvided = mobile?.trim().length > 0;
      return (
        (!nameProvided && !mobileProvided) || (nameProvided && mobileProvided)
      );
    }
  );

export const userValidationSchema = Yup.object().shape({
  _id: Yup.string(),
  firstname: Yup.string().required("Firstname is mandatory"),
  lastname: Yup.string().required("Lastname is mandatory"),
  country_code: Yup.string().required("Country Code is mandatory"),
  mobile: Yup.number()
    // .min(1000000000, "Please enter a valid mobile no.")
    .required("Mobile is mandatory")
    .test(
      "is-valid-phone",
      "Invalid mobile number",
      function (value) {
        const { country_code } = this.parent;
        if (!country_code || value == null || value === "") return false;

        const ccDigits = String(country_code).replace(/\D/g, "");
        const national = String(value).replace(/\D/g, "");
        if (!ccDigits || !national) return false;

        const e164 = `+${ccDigits}${national}`;
        return isValidPhoneNumber(e164);
      }
    ),
  // organization: Yup.string().required("Organization is mandatory"),
  email: Yup.string()
    .email("Please enter valid email address")
    .required("Email is mandatory"),
  role: Yup.string().required("Role is mandatory"),
  dob: Yup.string()
    .required("Date of birth is mandatory")
    .test(
      "valid-dob",
      "Please enter a valid date of birth",
      (val) => !!val && !Number.isNaN(Date.parse(val))
    )
    .test(
      "dob-not-future",
      "Date of birth cannot be in the future",
      (val) => {
        if (!val) return true;
        const parts = val.split("-");
        if (parts.length !== 3) return true;
        const y = Number(parts[0]);
        const m = Number(parts[1]);
        const d = Number(parts[2]);
        if (!y || !m || !d) return true;
        const chosen = new Date(y, m - 1, d);
        if (Number.isNaN(chosen.getTime())) return true;
        const today = new Date();
        const todayDay = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        );
        return chosen <= todayDay;
      }
    ),
  password: Yup.string().required("Password is mandatory"),
});
